import { defineComponent as _defineComponent } from 'vue'
import Status from '@/enum/Status';
import RequestsList, { RequestListProps } from '../RequestsList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const config: RequestListProps = {
  title: 'Bordereaux',
  subtitle: 'Aqui verás las solicitudes procesadas y no procesadas.',
  showExportButton: true,
  columns: ['status', 'code', 'insured_fullname', 'address', 'original_gross_bonus', 'validity', 'actions'],
  filters: {
    initial:  {
      status: [Status.Procesada, Status.No_Procesada],
    },
    mainSearcher: 'seguredName',
    fields: ['seguredName', 'status', 'policy_number'],
  }
};

return { __sfc: true,config, RequestsList }
}

})